import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfDraftDetail } from "./types";

// Reads a draft detail (row + attachments + allocation balance). Used by
// the orchestrator hook (use-mdf-runtime) to hydrate the form. Auto-save
// PATCHes do NOT invalidate this key — local form state owns the field
// values between server round-trips.
export function useMdfDraft(draftId: string | null) {
  return useQuery<MdfDraftDetail>({
    queryKey: queryKeys.mdf.draft(draftId ?? ""),
    queryFn: () => apiFetch<MdfDraftDetail>(`/portal/mdf/drafts/${draftId}`),
    enabled: !!draftId,
  });
}
